export const name = "ST_Y";
export const summary = `Gets the latitude from a point \`GEOGRAPHY\` value.`;
export const reference = `
## ST_Y

Gets the latitude from a point \`GEOGRAPHY\` value.

\`\`\`
ST_Y(point_geography_expression)
\`\`\`

### Description

Returns the latitude in degrees of the single-point input\`GEOGRAPHY\`.

For any input \`GEOGRAPHY\` that isn't a single point, including an empty \`GEOGRAPHY\`, \`ST_Y\` returns an error. Use the \`SAFE.\` prefix to return \`NULL\` instead.


### Return type

\`FLOAT64\`


### Example

See \`ST_X\` for example usage.




source: https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
`;
